<template>
  <div class="cf-page-container">
    <cf-loading-wrapper
      :is-loading="isLoading"
      :loader-type="'page'"
    >
      <error-page :is-page-load-error="isPageLoadError">
        <div class="cf-card cf-card--mobile cf-flex cf-flex--column cf-flex--gap-20 cf-clear-padding-bottom">
          <h1 class="cf-title cf-title--1">
            {{ title }}
          </h1>

          <faq-category
            v-for="(faqCategory, idx) in faqCategories"
            :key="idx"
            :faq-category="faqCategory"
          />
        </div>
      </error-page>
    </cf-loading-wrapper>
  </div>
</template>


<script>
  import FaqCategory from './faq-category/index.vue';

  import ErrorPage from '@/view/pages/shared/error-page/index.vue';
  import CfLoadingWrapper from '@/view/components/globals/cf-loading-wrapper/index.vue';


  export default {
    name: 'FaqPage',

    metaInfo() {
      return {
        title: 'FAQ\'s'
      };
    },

    components: {
      FaqCategory,
      ErrorPage,
      CfLoadingWrapper
    },

    data() {
      return {
        faqCategories: [],
        isLoading: false,
        isPageLoadError: false,
        title: null
      };
    },

    created() {
      this.onComponentCreated();
    },

    methods: {
      async onComponentCreated() {
        this.loadFaqs();
      },

      async loadFaqs() {
        this.isLoading = true;

        const { title, faqCategories } = await this.$store.dispatch('merchant/getMerchantFaqs');

        if (title && faqCategories) {
          this.title = title;

          this.faqCategories = faqCategories;
        }
        else {
          this.isPageLoadError = true;
        }

        this.isLoading = false;
      }
    }
  };
</script>
